import { serializable, primitive, object, list, alias } from 'serializr';
import { Organization as OrganisationMap } from './organization.model';

class CompanySize {
  @serializable(primitive())
  id?: number;
}

class CompanySector {
  @serializable(primitive())
  id?: number;
}

class CompanySubSector {
  @serializable(primitive())
  id?: number;
}

class CompanyIndustryGroup {
  @serializable(primitive())
  id?: number;
}

class Company {
  @serializable(object(CompanySize))
  size?: CompanySize;

  @serializable(object(CompanySector))
  sector?: CompanySector;

  @serializable(object(CompanySubSector))
  sub_sector?: CompanySubSector;

  @serializable(object(CompanyIndustryGroup))
  industry_group?: CompanyIndustryGroup;

  @serializable(primitive())
  organizational_boundary?: string;

  @serializable(primitive())
  reporting_month?: number;

  @serializable(primitive())
  baseline_year?: number;

  @serializable(primitive())
  recalculation_threshold?: number;
}

class Organization {
  @serializable(primitive())
  name?: string;
}

class PayloadData {
  @serializable(object(Company))
  company?: Company;

  @serializable(object(Organization))
  organization?: Organization;
}

export class Payload {
  @serializable(object(PayloadData))
  data?: PayloadData;
}

export class OrganisationMapPayload {
  @serializable(alias('organization_map', list(object(OrganisationMap))))
  organizationMap?: OrganisationMap[];

  @serializable(primitive())
  year?: number;
}
